import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./Store/Reducers/RootReducer";
import "./i18n";
import { QueryClientProvider , QueryClient} from "@tanstack/react-query";
const reduxStore = createStore(rootReducer);
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
   <QueryClientProvider client={queryClient}>
      <Provider store={reduxStore}>
        <App />
      </Provider>
    </QueryClientProvider> 
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
